import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { PortalService } from "../../../services/portal-service.service";
import { AuthService } from "../../../services/auth.service";
import { ModifyUserRequest, UserDetails } from "../../../models/user";
import { LogService } from "../../../services/log.service";

@Component({
  standalone: false,
  selector: "app-reset-question-tab",
  templateUrl: "./reset-question-tab.component.html",
  styleUrls: ["./reset-question-tab.component.scss"],
})
export class ResetQuestionTabComponent implements OnInit {
  ResetQuestionForm: UntypedFormGroup;
  error: any = null;
  success = false;
  saving = false;
  userData: UserDetails = new UserDetails();
  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private portalService: PortalService,
    private logService: LogService,
  ) {}

  ngOnInit() {
    this.ResetQuestionForm = this.fb.group({
      question: ["", [Validators.required]],
      answer: ["", [Validators.required]],
      currentpass: ["", [Validators.required]],
    });
    this.getDetails();
  }

  get f() {
    return this.ResetQuestionForm.controls;
  }

  async getDetails() {
    const user = this.authService.getToken();
    let userId = null;
    if (user) {
      userId = this.authService.JWTDecode(user).sub;
      this.userData = await this.portalService.getUser(userId);
      this.f.question.patchValue(this.userData.resetQuestion);
    }
  }

  resetMessage() {
    this.error = null;
    this.success = false;
  }

  async modifyResetQuestion() {
    this.resetMessage();
    if (this.saving) return;
    this.saving = true;
    const data: ModifyUserRequest = {
      user: {
        ...this.userData,
        resetQuestion: this.f.question.value,
        resetAnswer: this.f.answer.value,
      },
      existingPassword: this.f.currentpass.value,
    };

    try {
      await this.portalService.updateUser(this.userData.id, data);
      this.success = true;
      this.getDetails();
    } catch (error) {
      this.logService.log("Failed to change reset question: ", error);
      this.error = error;
      this.success = false;
    } finally {
      this.saving = false;
    }
  }

  saveDisabled(): boolean {
    return this.saving || this.ResetQuestionForm.invalid;
  }
} // end
